import { filter, map, pipe } from 'remeda'

import { getChainConfigEntry } from '@/config/chain'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { OngoingCampaign } from '@/features/spark-rewards/data/ongoingCampaignsQueryOptions'
import { MarketSparkRewards } from '@/features/spark-rewards/types'
import { assets } from '@/ui/assets'

export interface AssignMarketSparkRewardsArgs {
  campaigns: Extract<OngoingCampaign, { type: 'sparklend' }>[]
  action: 'supply' | 'borrow'
  reserveTokenSymbol: TokenSymbol
  chainId: number
}

export function assignMarketSparkRewards({
  campaigns,
  action,
  reserveTokenSymbol,
  chainId,
}: AssignMarketSparkRewardsArgs): MarketSparkRewards[] {
  const { tokenDefinitionRepository } = getChainConfigEntry(chainId)

  function campaignToReward(action: 'supply' | 'borrow') {
    return (campaign: OngoingCampaign): MarketSparkRewards => ({
      rewardTokenSymbol: campaign.rewardTokenSymbol,
      rewardTokenLogo: tokenDefinitionRepository.findBySymbol(campaign.rewardTokenSymbol)?.logo ?? assets.token.unknown,
      action,
      longDescription: campaign.longDescription,
      apy: campaign.type === 'sparklend' ? campaign.apy : undefined,
    })
  }

  function includesReserve(tokenSymbol: TokenSymbol, action: 'supply' | 'borrow') {
    return (campaign: Extract<OngoingCampaign, { type: 'sparklend' }>) =>
      action === 'supply'
        ? campaign.depositTokenSymbols.includes(tokenSymbol)
        : campaign.borrowTokenSymbols.includes(tokenSymbol)
  }

  return pipe(campaigns, filter(includesReserve(reserveTokenSymbol, action)), map(campaignToReward(action)))
}
